import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { storeModules, storeTypes } from '../../store';
import { namespace, Getter, Action } from 'vuex-class';
import { LabelSetting } from '../../i18n/locale-helper';
import { SERVICE_LINKS } from "../../common/constants";
import { logIframeMessageSent, logIframeMessageReceived } from '../../utils/web-view';

const CommonGetter = namespace(storeModules.Common, Getter);
const CommonAction = namespace(storeModules.Common, Action);

const TARGET_ORIGIN = '*';
const MAP_TRANSFER_MESSAGE = 'RESULT_VALUE';
// const MAP_TRANSFER_MESSAGE_INIT = 'INIT_MAP';
const MAP_TRANSFER_MESSAGE_INIT_RESULT = 'INIT_MAP_COMPLETED';


@Component({
    name: "ExternalMapComponent",
    template: require('./template.html')
})
class ExternalMapComponent extends Vue {

    @CommonGetter mapRegions;
    @CommonGetter mapOptions;

    dtDefaultSettingOptions: any;
    dtDefaultSettingRegions: any;
    loading: boolean = true;
    @Prop({ default: SERVICE_LINKS.MAP_WEBAPP_URL })
    settingSrc: string;

    @Prop({ default: 'allow-scripts allow-same-origin' })
    settingSandbox: string;
    @Prop({ default: false, type: [Boolean] })
    readOnly: boolean;
    @Prop({ default: false, type: [Boolean] })
    fetchButtonVisibile: boolean;
    @Prop({ default: .28 })
    heightRatio: number;

    @Prop({ default: null, type: [String] })
    viewHeight: string;

    @Prop({ default: () => [], type: [Array] })
    items: any;

    @Prop({ default: true, type: [Boolean] })
    actionButtonsVisible: boolean;

    dtDefaultSettingMapOptions: any;
    _$el: any = {};

    get coSettingFetchDataVisible(): boolean {
        return this.fetchButtonVisibile;
    }
    get coSrc(): string {
        return this.settingSrc;
    }
    get coReadOnly() {
        return this.readOnly;
    }
    get coSandbox(): string {
        return this.settingSandbox;
    }
    get coHeight(): number {
        return screen.availHeight * this.heightRatio;
    }

    get coSettingStyles() {
        if (this.viewHeight) {
            return {
                height: this.viewHeight,
                width: "100%"
            }
        }
        return {
            height: `${this.coHeight}px`,
            width: '100%'
        };
    }

    get lblAction() {
        return LabelSetting.Action;
    }
    /**
     *
     */
    constructor() {
        super();
        const options = localStorage.getItem('options');
        const regions = localStorage.getItem('regions');
        this.dtDefaultSettingMapOptions = {
            items: this.items,
            options: options ? JSON.parse(options) : {},
            data: regions ? JSON.parse(regions) : {},
        };
    }
    @CommonAction(storeTypes.Get.MAPOPTIONS)
    storeGetMapOptions: () => Promise<any>;

    @CommonAction(storeTypes.Get.MAPREGIONS)
    storeGetMapRegions: () => Promise<any>;

    created() {
        if (this.dtDefaultSettingMapOptions.options.isReadOnlyMap === undefined) {
            this.storeGetMapOptions()
                .then(options => this.dtDefaultSettingMapOptions.options = options)
                .then(() => {
                    this.handlePostData();
                })
                .catch(error => console.log(error))
        }
        if (Object.keys(this.dtDefaultSettingMapOptions.data).length <= 0) {
            this.storeGetMapRegions()
                .then(regions => this.dtDefaultSettingMapOptions.data = regions)
                .catch(error => console.log(error))
        }
    }

    _postDataCleanner: any;
    handlePostData() {
        let vm = this;
        if (vm.mapOptions !== null && vm.mapRegions !== null && vm.dtDefaultSettingMapOptions.options != null) {
            clearTimeout(vm._postDataCleanner)
            vm._postDataCleanner = setTimeout(() => {
                vm.dtDefaultSettingMapOptions.options.isReadOnlyMap = this.coReadOnly;
                logIframeMessageSent('ExternalMap', vm.dtDefaultSettingMapOptions, 'ExternalMap');
                vm._$el.contentWindow.postMessage(vm.dtDefaultSettingMapOptions, TARGET_ORIGIN);
            }, 500)
        }
    }
    _fetchDataCleanner: any;

    handleFetchData() {
        let vm = this;
        clearTimeout(vm._fetchDataCleanner);
        vm._fetchDataCleanner = setTimeout(() => {
            logIframeMessageSent('ExternalMap', MAP_TRANSFER_MESSAGE, 'ExternalMap');
            vm._$el.contentWindow.postMessage(MAP_TRANSFER_MESSAGE, TARGET_ORIGIN);
        }, 300);
    }
    _initMapCleanner: any;
    _initMapIntervalCleanner: any;

    handleOnMessage(e) {
        logIframeMessageReceived('ExternalMap', e.data, 'ExternalMap');
        if (e.data === MAP_TRANSFER_MESSAGE_INIT_RESULT) {
            this.handlePostData();
        }
        else {
            try {
                if (typeof e.data === 'string' && e.data.indexOf('[') !== -1) {
                    this.$emit('fetch', JSON.parse(e.data));
                }
            } catch (ex) { console.log(ex); }
        }
    }

    mounted() {
        let vm = this;
        vm.$nextTick(() => {
            vm._initMapIntervalCleanner = setInterval(() => {
                vm._$el = vm.$refs.iframeRef as any;

                if (vm._$el !== null && vm._$el !== undefined) {
                    // vm.handlePostData()
                    // setTimeout(() => vm.handlePostData(), 3000);;
                    // clearInterval(vm._initMapIntervalCleanner);
                }
            }, 100);

            window.addEventListener("message", this.handleOnMessage);

            vm.$watch('items', (value) => {
                vm.dtDefaultSettingMapOptions.items = value;
                vm.handlePostData();
            }, { deep: true });
        });
    }
    handlerLoadIframe(e) {
        this.loading = false;
        this.handlePostData();
    }
    beforeDestroy() {
        clearTimeout(this._fetchDataCleanner);
        clearTimeout(this._postDataCleanner);
        clearTimeout(this._initMapIntervalCleanner);
        clearTimeout(this._initMapCleanner);

        this.dtDefaultSettingOptions = null;
        this.dtDefaultSettingRegions = null;
        this.dtDefaultSettingMapOptions = null;
        this._$el = null;
        this._fetchDataCleanner = null;
        this._postDataCleanner = null;
        this._initMapIntervalCleanner = null;
        this._initMapCleanner = null;

        window.removeEventListener("message", this.handleOnMessage);
    }
}
export default ExternalMapComponent;